export type LessonConfig = {
  title: string;
  subtitle: string;
  image: string;
  lessonCode: string;
  blurb: string;
}[];

export const CHP_LESSON_CONFIG: LessonConfig = [
  {
    subtitle: "Welcome",
    title: "Introduction to Your New Program",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-00.svg",
    lessonCode: "L00",

    blurb:
      "Welcome to the Amos Institute! In this introductory lesson we discuss how the Bredesen Protocol differs from the conventional approach to treating Alzheimer's disease.",
  },
  {
    subtitle: "Lesson One",
    title: "Ketoflex Nutrition Plan",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-01.jpg",
    lessonCode: "L01",

    blurb:
      "The food you eat is either the most powerful form of medicine, or the slowest form of poison. Compliance to your nutrition program is vital for your success. In this lesson we will be discussing the specifics of the Ketoflex Nutrition Program.",
  },
  {
    subtitle: "Lesson Two",
    title: "Time Management and Follow Through",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-02.jpg",
    lessonCode: "L02",

    blurb:
      "This lesson isn’t about eating, exercising, sleeping, or stress, but it has everything to do with how successful you are going to be on the Bredesen Protocol. We will discuss the imperative tools of time management and follow through.",
  },
  {
    subtitle: "Lesson Three",
    title: "Physical Exercise",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-03.jpg",
    lessonCode: "L03",

    blurb:
      "Physical exercise is necessary for optimal cognitive function. In this lesson, we review the research in support of physical activity to maintain a healthy brain and your physical activity requirement on the program.",
  },
  {
    subtitle: "Lesson Four",
    title: "Optimizing Your Sleep Hygiene",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-04.jpg",
    lessonCode: "L04",

    blurb:
      "Our brain undergoes cellular processes for self repair while we sleep, but many of use have decades of sleep deficit. Without adequate, restorative sleep, we deprive our brains of the opportunity to heal.",
  },
  {
    subtitle: "Lesson Five",
    title: "Gut Health",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-05.jpg",
    lessonCode: "L05",

    blurb:
      "In this lesson we cover the importance of gut health because the gut and the brain are intricately connected. Trouble in the gut can manifest in the brain, which is why maintaining optimal gut health is key for your recovery.",
  },
  {
    subtitle: "Lesson Six",
    title: "Organic & Seasonal Foods",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-06.jpg",
    lessonCode: "L06",

    blurb:
      "There’s a lot of controversy surrounding organic foods. Are they worth the increase in price? Is there really any difference between organic and conventional produce? We address those questions in this lesson.",
  },
  {
    subtitle: "Lesson Seven",
    title: "Brain Exercise",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-07.jpg",
    lessonCode: "L07",

    blurb:
      "Brain exercise is necessary for optimal cognitive function. In this lesson, we review the research in support of brain training and discuss the program that we recommend.",
  },
  {
    subtitle: "Lesson Eight",
    title: "Meditation",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-08.jpg",
    lessonCode: "L08",

    blurb:
      "The benefits of daily meditation are simply outstanding. In this lesson, we review the research into the cognitive impact of meditation and describe the broad categories of meditation so that you can choose a practice that resonates with you.",
  },
  {
    subtitle: "Lesson Nine",
    title: "ApoE4 & Mild Ketosis",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-09.jpg",
    lessonCode: "L09",

    blurb:
      "You may have heard about the benefits of ketosis for cognition, although much confusion and misinformation surrounds this subject. In this lesson we discuss what ketosis is, how it relates to ApoE4, and why we may need to alter your diet further so that you can achieve metabolic flexibility.",
  },
  {
    subtitle: "Lesson Ten",
    title: "Supplements",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-10.jpg",
    lessonCode: "L10",

    blurb:
      "Much like the foods you eat, not all supplements on the market are created equally. In this lesson, we explain issues regarding supplement regulation and how to make sure that the supplements you’re taking are of the best quality.",
  },
  {
    subtitle: "Lesson Eleven",
    title: "Portions, Planning, & Prep",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-11.jpg",
    lessonCode: "L11",

    blurb:
      "Understanding proper portion sizes is key to properly implement your nutrition plan. Adding some meal planning and prepping will help make compliance to your nutrition plan easier.",
  },
  {
    subtitle: "Lesson Twelve",
    title: "Epigenetics",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-12.jpg",
    lessonCode: "L12",

    blurb:
      "Our genetic makeup does not control our health destiny. We have the ability to alter how our genes express themselves based on our lifestyle, and this concept is known as ‘epigenetics’.",
  },
  {
    subtitle: "Lesson Thirteen",
    title: "Stress Management & Telomeres",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-13.jpg",
    lessonCode: "L13",

    blurb:
      "Stress management is an essential part of your program. In this lesson, we discuss recent research that highlights how chronic stress affects our biological age, and in turn alters our brain health.",
  },
  {
    subtitle: "Lesson Fourteen",
    title: "Your Circadian Clock",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-14.svg",
    lessonCode: "L14",

    blurb:
      "Circadian rhythms are real biological processes that all living things exhibit over the course of the day. Living in sync with your circadian rhythms or clock can help you optimize your cognition and improve your health outcomes.",
  },
  {
    subtitle: "Lesson Fifteen",
    title: "The Toxic Body Burden",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-15.svg",
    lessonCode: "L15",

    blurb:
      "We are exposed to toxins in far greater quantity than our bodies have evolved to handle. In this lesson, we review why toxins are such a powerful contributor to chronic diseases and what you can do to reduce your exposure.",
  },
  {
    subtitle: "Lesson Sixteen",
    title: "Gluten & Dairy: The Evidence",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-16.jpg",
    lessonCode: "L16",

    blurb:
      "Gluten free and dairy free are controversial terms and trends in the nutrition world. In this lesson, we review the research behind gluten and dairy in the human diet, and the reasons why we’ve recommended you exclude it from your diet.",
  },
  {
    subtitle: "Lesson Seventeen",
    title: "Mindfulness",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-17.jpg",
    lessonCode: "L17",

    blurb:
      "In this lesson, our focus is on the art of living in a state of mindfulness. We will review what it means to be mindful and how to practice mindfulness in our increasingly mind-less society.",
  },
  {
    subtitle: "Lesson Eighteen",
    title: "Grounding",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-18.jpg",
    lessonCode: "L18",

    blurb:
      "Grounding, or earthing, refers to directly connecting any part of the body to the earth’s surface. This is a technique that has been used for centuries to deliver a positive psychological and physiological benefit. However, recent evidence-based research has shown that grounding offers an anti-inflammatory and antioxidant effect.",
  },
  {
    subtitle: "Lesson Nineteen",
    title: "Air Quality",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-19.jpg",
    lessonCode: "L19",

    blurb:
      "The latest research shows that air pollution from fossil fuel exhaust may be a major driver of Alzheimer’s disease. In this lesson we review the science behind our air quality and how our environment influences our risk of developing cognitive decline.",
  },
  {
    subtitle: "Lesson Twenty",
    title: "Alcohol Intake & Navigating Social Gatherings",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-20.jpg",
    lessonCode: "L20",

    blurb:
      "Wondering how to deal with social gatherings like cocktail parties, holidays, and restaurants while on your nutrition program? Curious about how alcohol fits into the Bredesen Protocol? In this lesson we break down what you need to know and the tools to stay compliant.",
  },
  {
    subtitle: "Lesson Twenty One",
    title: "Staying Hydrated",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-21.jpg",
    lessonCode: "L21",

    blurb:
      "Proper hydration is essential to optimal health. The importance of water goes far beyond just quenching thirst. In this lesson we cover your hydration needs and the research behind why proper hydration is so crucial for you recovery.",
  },
  {
    subtitle: "Lesson Twenty Two",
    title: "Oral Hygiene",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-22.jpg",
    lessonCode: "L22",

    blurb:
      "More and more research is linking poor oral health with Alzheimer’s disease. Pathogenic bacteria in the mouth can cross the blood brain barrier and stimulate production of beta amyloid plaque.",
  },
  {
    subtitle: "Lesson Twenty Three",
    title: "Building Your New Healthy Lifestyle",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-23.jpg",
    lessonCode: "L23",

    blurb:
      "Science has shown that cognitive improvement can be achieved through many avenues. In this lesson, you are invited to explore other evidence based lifestyle interventions to further enhance your cognitive health.",
  },
  {
    subtitle: "Lesson Twenty Four",
    title: "Spirituality",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-24.jpg",
    lessonCode: "L24",

    blurb:
      "True healing requires a connection of the body and spirit. The benefit of this connectedness to something greater than ourselves is documented in scientific literature. In this lesson, we explore the research and how to go about establishing or nurturing this mind-body-spirit connection.",
  },
  {
    subtitle: "Lesson Twenty Five",
    title: "Blue Zones",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-25.jpg",
    lessonCode: "L25",
    blurb:
      "Blue Zones are areas of the world with unusually dense populations of centenarians, which means people who live to be 100 years old and older in great health. In this lesson, we discuss the nutrition and lifestyle characteristics of some of the best known Blue Zones.",
  },
  {
    subtitle: "Lesson Twenty Six",
    title: "Gratitude",
    image:
      "https://amosinstitute-public-assets.s3-us-west-2.amazonaws.com/chp/thumbnails/chp-thumb-26.jpg",
    lessonCode: "L26",
    blurb:
      "Countless studies have investigated the impact of gratitude on psychological and physiological health. Our thoughts can influence our genetic expression. Are your thoughts helping your express the best of your genes?",
  },
];
